import React, { useEffect } from 'react'
import feet from '../../images/feet.png'
import { RoadmapTitle, Para, SubRoad } from './RoadElements'
import './RoadStyle.css'
import AOS from 'aos'
import 'aos/dist/aos.css'



function Roadmap() {  
    useEffect(()=>{
        AOS.init();
    });
    
    return(
        <>
        
    <div className="container" id="Roadmap">
            
        <RoadmapTitle>ROADMAP</RoadmapTitle>
        <SubRoad>The roadmap is based on the story framework.</SubRoad>

          <img src={feet} className ="feet" />
          <div style={{marginBottom:"2%"}} data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />25% Activate DNMS mailbox-Citizens can submit their content to the DNMS media</Para></div>
          
          <div style={{marginBottom:"2%"}}  data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />40% Open the four private islands-An exclusive channel for every island and its residents</Para></div>

          <div style={{marginBottom:"2%"}}  data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />60% A Mysterious Drop-Every citizen receives a special NFT drop</Para></div>

          <div style={{marginBottom:"2%"}}  data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />75% DNMS Festival-The first 10 winners will receive a <span style={{fontWeight:"900"}}>DINO NFT</span> and a <span style={{fontWeight:"900"}}>PHYSICAL ART PIECE</span> </Para></div>

          <div style={{marginBottom:"2%"}}  data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />90% The Dinomension Concept Store-We’re turning the Dinomension into reality</Para></div>        
          
          <div style={{marginBottom:"2%"}}  data-aos="fade-up" data-aos-delay="200"><Para><img src={feet} className ="feet2" />100% Real copies of DNMS publications are now available!</Para></div>

    </div>
    
        </>
    )}


export default Roadmap


